import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./layouts/main/main.layout').then(l => l.MainLayout),
        loadChildren: () => import('./pages/main/main.routes').then(r => r.mainRoutes)
    },
    {
        path: 'account',
        loadComponent: () => import('./layouts/main/main.layout').then(l => l.MainLayout),
        loadChildren: () => import('./pages/account/account.routes').then(r => r.accountRoutes)
    }

];
